import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  useTheme, 
  alpha 
} from '@mui/material';
import vlogimg from '../../Images/vlogimg.png';

export default function Blogs() {
  const theme = useTheme();

  return (
    <Box sx={{ py: 10, bgcolor: 'background.default' }}>
      <Container>
        <Grid container spacing={8} alignItems="center">
          {/* Image Side */}
          <Grid item xs={12} md={6}>
            <Box 
              sx={{ 
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: -20,
                  left: -20,
                  width: '100%',
                  height: '100%',
                  bgcolor: alpha('#D4AF37', 0.1),
                  borderRadius: '30px',
                  zIndex: 0
                }
              }}
            >
              <Box 
                component="img" 
                src={vlogimg} 
                alt="Learning Skill Up" 
                sx={{ 
                  width: '100%', 
                  borderRadius: '30px', 
                  display: 'block', 
                  position: 'relative',
                  zIndex: 1,
                  boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                }} 
              />
            </Box>
          </Grid>

          {/* Content Side */}
          <Grid item xs={12} md={6}>
            <Box sx={{ pl: { md: 4 } }}>
              <Typography 
                variant="h6" 
                fontWeight={800} 
                color="primary" 
                gutterBottom
                sx={{ textTransform: 'uppercase', letterSpacing: '2px' }}
              >
                Philosophy of Growth
              </Typography>
              <Typography 
                variant="h2" 
                fontWeight={900} 
                gutterBottom 
                sx={{ 
                  mb: 3,
                  lineHeight: 1.1,
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, #D4AF37)`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Learning! Skill Up
              </Typography>
              
              <Typography 
                variant="body1" 
                color="text.secondary" 
                sx={{ 
                  fontSize: '1.2rem', 
                  lineHeight: 1.8,
                  mb: 4 
                }}
              >
                At KaaS, we believe that true growth comes from a blend of knowledge, practical exposure, and personal exploration. Our programs are designed not just to teach concepts, but to immerse learners in real-world experiences that prepare them for the challenges of the dairy, poultry, and companion animal health industries.
              </Typography>
              
              <Typography 
                variant="body1" 
                color="text.secondary" 
                sx={{ 
                  fontSize: '1.2rem', 
                  lineHeight: 1.8,
                  fontStyle: 'italic',
                  borderLeft: '4px solid',
                  borderColor: '#D4AF37',
                  pl: 3,
                  bgcolor: alpha('#D4AF37', 0.05),
                  py: 2,
                  borderRadius: '0 15px 15px 0'
                }}
              >
                By combining structured learning with hands-on training and expert mentorship, we help individuals discover their potential, sharpen their skills, and confidently pursue their professional goals.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
